export default {
  init() {
    // JavaScript to be fired on all pages
    $('.burger').on('click', function() {
      $('.mobile-nav').fadeToggle();

    })

    $('.our-products-link').on('click', function() {
      $('.sub-menu').toggleClass('active');
    });

    $('.our-products-trigger').on('click', function() {
      $(this).toggleClass('bg-white');
      $('#productsUnderbar').toggleClass('hidden').toggleClass('block');
      $('#greenUnderbar').toggleClass('hidden').toggleClass('block');
    })

    $('.woocommerce-notices-wrapper').attr('id', 'alertBox');


    $('#billing_gazchaps_getaddress_io_postcode_lookup_button_field').find('br').remove()
    $('#shipping_gazchaps_getaddress_io_postcode_lookup_button_field').find('br').remove()

    $(document).ready(function($) {
      $(document).ajaxComplete(function() {
          jQuery( 'html, body' ).stop();

    });

     $(document).on('click', '.dismiss', function(){
      $('.woocommerce-message').hide();
      console.log('test');
    });
  });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js